import { render } from "./ChangeDelivery.vue?vue&type=template&id=129a8748"
import script from "./ChangeDelivery.vue?vue&type=script&lang=js"
export * from "./ChangeDelivery.vue?vue&type=script&lang=js"

import "./ChangeDelivery.vue?vue&type=style&index=0&id=129a8748&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__